import { gql } from '@apollo/client';

export const PROCESS_CAMPAIGN = gql`
mutation ProcessCampaign($id: ID!, $promptTemplate: String, $scheduledFor: ISO8601DateTime, $customerIds: [ID!], $tagIds: [ID!], $dateFilters: [JSON!], $advancedFilters: [JSON!]) {
  processCampaign(input: { id: $id, promptTemplate: $promptTemplate, scheduledFor: $scheduledFor, customerIds: $customerIds, tagIds: $tagIds, dateFilters: $dateFilters, advancedFilters: $advancedFilters }) {
    campaign {
      id
      name
    }
    campaignMessagesCount
    errors
  }
}
`;

export const GENERATE_PREVIEW_MESSAGES = gql`
  mutation GeneratePreviewMessages($kind: String!, $productIds: [ID!], $customerIds: [ID!], $tagIds: [ID!], $dateFilters: [JSON!], $advancedFilters: [JSON!], $promptTemplate: String, $discountPercentage: Float, $selectedGroupId: ID, $followUpObjective: String) {
    generatePreviewMessages(input: {
      kind: $kind, 
      productIds: $productIds, 
      customerIds: $customerIds,
      tagIds: $tagIds,
      dateFilters: $dateFilters,
      advancedFilters: $advancedFilters,
      promptTemplate: $promptTemplate, 
      discountPercentage: $discountPercentage,
      selectedGroupId: $selectedGroupId,
      followUpObjective: $followUpObjective
    }) {
      messages {
        customerName
        lastPurchase
        favoriteProduct
        message
      }
      errors
    }
  }
`;

export const CREATE_CAMPAIGN = gql`
mutation CreateCampaign($input: CampaignAttributes!) {
  createCampaign(input: { attributes: $input }) {
    campaign {
      id
      name
      kind
      discountPercentage
      followUpObjective
      campaignMode
      expectedCustomersCount
      onlyVerifiedWhatsappCampaigns
      group {
        id
        name
      }
      selectedProducts {
        id
        name
      }
      images {
        id
        url
      }
    }
    errors
  }
}
`;

export const DELETE_CAMPAIGN = gql`
mutation DeleteCampaign($id: ID!) {
  deleteCampaign(input: { id: $id }) {
    success
    errors
  }
}
`;

export const DUPLICATE_CAMPAIGN = gql`
mutation DuplicateCampaign($id: ID!, $name: String) {
  duplicateCampaign(input: { id: $id, name: $name }) {
    campaign {
      id
      name
      kind
      expectedCustomersCount
      campaignMode
    }
    campaignMessagesCount
    errors
  }
}
`;

// Rest of the file...